export const document_approval_types = {
  cnic: {
    text: 'National Identity Card',
    value: 'cnic',
  },
  driving_license: {
    text: 'Driving License',
    value: 'driving_license',
  },
  passport: {
    text: 'Passport',
    value: 'passport',
  }
}